@switch (module) {
    @case (moduleTypes.IM) {
        <uc-periodic-notification-detail-moi
            [module]="module"
            [id]="id"
            [cerrixTab]="tab"
        ></uc-periodic-notification-detail-moi>
    }
    @case (moduleTypes.Incidents) {
        <uc-periodic-notification-detail-incidents
            [module]="module"
            [id]="id"
            [cerrixTab]="tab"
        ></uc-periodic-notification-detail-incidents>
    }
}
